import toThreadTimestampMs from '@/lib/threads/toThreadTimestampMs.js';

const isIncomingThreadMetadataStale = ({ existingThread = null, incomingThread = null }) => {
  const existingUpdatedAtMs = toThreadTimestampMs(existingThread?.updatedAt || existingThread?.updated_at);
  const incomingUpdatedAtMs = toThreadTimestampMs(incomingThread?.updatedAt || incomingThread?.updated_at);

  if (!Number.isFinite(existingUpdatedAtMs)) {
    return false;
  }

  if (!Number.isFinite(incomingUpdatedAtMs)) {
    return true;
  }

  return incomingUpdatedAtMs < existingUpdatedAtMs;
};

export default isIncomingThreadMetadataStale;
